// NotFound.js
import React from 'react';

const NotFound = () => {
  return (
     <section>
     <div className="mx-auto h-screen grid place-items-center bg-colors-container">
     <div>
      <h1 style={{
        color:"white",
        fontSize:"30px",
        textAlign:"center",
        fontWeight:"bold"
      }}>404 - Página no encontrada</h1>
      <p style={{
        color:"white",
        fontSize:"14px",
        textAlign:"center",
      }}>Lo sentimos, la página que estás buscando no existe.</p>
    </div>
     </div>
   </section>
  );
};

export default NotFound;
